import React, {useEffect, useRef, useState} from "react";
import BodyContainer from "../Common/BodyContainer/BodyContainer";
import {makeStyles, withStyles} from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import MenuItem from "@material-ui/core/MenuItem";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Badge from "@material-ui/core/Badge";
//import CarComponent from "../CarList/CarComponent";
import Button from "@material-ui/core/Button";
import FormHelperText from "@material-ui/core/FormHelperText";
import {checkEmployeeAppointment, getBrands, sendEmail} from "../HTTPS/apisInterface";
import Lottie from 'react-lottie';
import mailAnimation from './mailAnimation.json';
//import {carBrands} from "../../AppConstants";
import {useHistory, useParams} from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Alert from "@material-ui/lab/Alert";
import {InputLabel, Select} from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
	margin: {
		margin: theme.spacing(1),
	},
	root: {
	}
}));




export default function (props) {
	const isMobile = useMediaQuery('(max-width:766px)');
	const history = useHistory();
	const [image,setImage] = useState();
	const [alert,setAlertView]=useState('hidden');
	const [message,setMessage] = useState({status:"success",message:""});
	const [submitDisableButton,setDisableButton] = useState(false);
	const [brands,setBrands] = useState([]);
	const [selectedBrand,setSelectedBrand] = useState('');
	let { brandLocation } = useParams();

	const isBusyAppointment = (appointment) => {
		if (!appointment || typeof appointment !== "object") {
			return false;
		}

		if (typeof appointment.isBusy === "boolean") {
			return appointment.isBusy;
		}

		if (typeof appointment.hasDefinitiveMeeting === "boolean" && !appointment.hasDefinitiveMeeting) {
			return false;
		}

		if (typeof appointment.isDefinitiveMeeting === "boolean" && !appointment.isDefinitiveMeeting) {
			return false;
		}

		const rawStatus =
			appointment.showAs ||
			appointment.availability ||
			appointment.scheduleStatus ||
			appointment.status;

		if (typeof rawStatus === "string") {
			const normalizedStatus = rawStatus.trim().toLowerCase();
			if (normalizedStatus === "busy" || normalizedStatus === "oof") {
				return true;
			}
			if (
				normalizedStatus === "free" ||
				normalizedStatus === "tentative" ||
				normalizedStatus === "workingelsewhere" ||
				normalizedStatus === "unknown"
			) {
				return false;
			}
		}

		// Backward compatible fallback when the API only returns occupied slots without a status field.
		return true;
	}

	useEffect(()=>{
		// Check if required props are available
		if (!props.employee || !props.currentDate || !props.timeSlot) {
			setLoading(false);
			setShowPage(false);
			return;
		}
		
		const img = new Image();
		img.src =  props.employee.image !== false ? props.employee.image : '/assets/img/manplaceholder.png'; // by setting an src, you trigger browser download
		img.onload = () => {
			setImage(img.src);
		}
		const selectedDate = `${props.currentDate.getFullYear()}-${('0'+(props.currentDate.getMonth()+1)).slice(-2)}-${('0'+props.currentDate.getDate()).slice(-2)}`
		let isFound = false;
		checkEmployeeAppointment({"email":props.employee.email,"start_date":selectedDate}).then((response)=>{
			setLoading(false);
			if(response["message"]){
				history.goBack();
			}
			else{
				if (Array.isArray(response)) {
					response.forEach(item=>{
						if(item["start"] === props.timeSlot && isBusyAppointment(item)){
							setShowForm(false);
							setShowPage(true);
							isFound = true;
						}
					})
				} else {
					console.error(
						"Expected 'response' to be an array, but got:",
						response,
						"Type:",
						typeof response
					);
				}
			}
			if(!isFound){
				setShowPage(true);
				setLoading(false);
			}
		})
		getBrands().then(response=>{
			setBrands(response);
		})
	},[history, props.currentDate, props.employee.email, props.employee.image, props.timeSlot])
	const classes = useStyles();
	const StyledBadge = withStyles((theme) => ({
		badge: {
			backgroundColor: !props.employee || props.employee.period == null || props.employee.period.length === 0? '#b80c0c' :'#44b700',
			color: !props.employee || props.employee.period == null || props.employee.period.length === 0 ? '#b80c0c' :'#44b700',
			boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
			'&::after': {
				position: 'absolute',
				top: 0,
				left: 0,
				width: '100%',
				height: '100%',
				borderRadius: '50%',
				animation: `$ripple 1.2s ${!props.employee || props.employee.period === null || props.employee.period.length === 0	  ? 'once' : 'infinite'} ease-in-out`,
				border: '1px solid currentColor',
				content: '""',
			},
		},
		'@keyframes ripple': {
			'0%': {
				transform: 'scale(.8)',
				opacity: 1,
			},
			'100%': {
				transform: 'scale(2.4)',
				opacity: 0,
			},
		},
	}))(Badge);
	const formRef = useRef(null);
	const formDataInit = {
		voornaam:null,
		naam:null,
		telefoonNummber:null,
		emailAdres:null,
		adres:null,
		huidingVoertuigNummerPlat:null,
		extraInfo:null,
		brand:null,
		model:null

	}
	/*	proefritGewenst:null,*/
	const [formData,updateFormData] = useState(formDataInit);
	const [formErrors,setFormErrors] = useState({});
	const [showForm,setShowForm] = useState(true);
	const [showPage,setShowPage] = useState(false);
	const [acceptPrivacyPolicy,setPrivacyPolicy] = useState(false);
	const handleChange = (e) => {
		console.log(e.target.name,e.target.value)
		if(e.target.name === "brand"){
			setSelectedBrand(e.target.value);
		}
		updateFormData({
			...formData,
			[e.target.name]: e.target.value
		});
		console.log(formData)
	};
	const defaultOptions = {
		loop: true,
		autoplay: true,
		animationData: mailAnimation,
		rendererSettings: {
			preserveAspectRatio: 'xMidYMid slice'
		}
	};
	const validateTextField = (value)=>{
		if(value === null) return false;
		if(value === " ") return false;
		return true;
	}
	const validateEmailField = (value)=>{
		if(value === null) return false;
		const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
		return emailPattern.test(value);
	}
	const [loading,setLoading] = useState(true);
		const sendEmails = ()=>{
		// Check if required props are available
		if (!props.employee || !props.currentDate || !props.timeSlot) {
			setAlertView('visible');
			setMessage({message:"Missing required information. Please go back and select an appointment time.",status: "error"});
			setTimeout(()=>{
				setAlertView('hidden');
			},2400);
			return;
		}
		
		let errorsObject = {};
		Object.keys(formData).forEach(item=>{
			const validation =  item !=='emailAdres' ? validateTextField(formData[item]) : validateEmailField(formData[item]);
			if(validation === false){
				if(item !== 'adres' && item !=='huidingVoertuigNummerPlat' && item !== 'extraInfo'){
					errorsObject[item] = true;
				}
			}
		})
		setFormErrors(errorsObject);
		if(Object.keys(errorsObject).length === 0){
			setDisableButton(true);
			formData['locationName'] = brandLocation;
			formData['location'] = brandLocation;
			const extraHour = `${('0'+(parseInt(props.timeSlot.split(":")[0] ) + 1)).slice(-2)}:${props.timeSlot.split(":")[1]}`;
			let startEventDate = `${props.currentDate.toISOString().split("T")[0]}T${props.timeSlot}`;
			let endEventDate = `${props.currentDate.toISOString().split("T")[0]}T${extraHour}`;
			formData['startDate'] = startEventDate;
			formData['selectedDate'] =`${props.currentDate.toLocaleDateString('nl-BE',{ weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' })} - ${props.timeSlot} -> ${extraHour} `;
			formData['endDate'] = endEventDate;
			formData['startTime'] = startEventDate;
			formData['endTime'] = endEventDate;
			formData['employeeName'] = props.employee.name;
			formData['employeeEmail'] = props.employee.email;
			formData['selectedDateIso'] = props.currentDate;
			formData['timePeriod'] = props.timeSlot;

			sendEmail(formData).then(response=>{
				// Log response for debugging
				console.log('Email send response:', response);
				
				// Check if all status codes are in the 2xx success range (200-299)
				// Also handle cases where status codes might be strings or undefined
				const getStatusCode = (status) => {
					if (typeof status === 'number') return status;
					if (typeof status === 'string') return parseInt(status, 10);
					return null;
				};
				
				const statusEmployee = getStatusCode(response.statusEmployee);
				const statusClient = getStatusCode(response.statusClient);
				const statusReserved = getStatusCode(response.statusReserved);
				
				const isEmployeeSuccess = statusEmployee !== null && statusEmployee >= 200 && statusEmployee < 300;
				const isClientSuccess = statusClient !== null && statusClient >= 200 && statusClient < 300;
				const isReservedSuccess = statusReserved !== null && statusReserved >= 200 && statusReserved < 300;
				const hasReservedStatus = response.statusReserved !== undefined && response.statusReserved !== null;
				
				// Consider it successful if employee and client emails were sent successfully
				// If statusReserved is present, it must also be successful; if not present, we don't require it
				const isSuccess = isEmployeeSuccess && isClientSuccess && (hasReservedStatus ? isReservedSuccess : true);
				
				if(isSuccess){
					props.reactGA.pageview(window.location.pathname + window.location.search +"?success=true");
					props.reactGA.event({
						category: "Booking",
						action: "Form success"
					})
					history.push({search:"success=true",state:history.location.state})
					setShowForm(false);
					updateFormData(formDataInit);
					setSelectedBrand('');
					setDisableButton(false);
				}else{
					// Log which status codes failed for debugging
					console.error('Booking failed - Status codes:', {
						statusEmployee: response.statusEmployee,
						statusClient: response.statusClient,
						statusReserved: response.statusReserved,
						fullResponse: response
					});
					setAlertView('visible');
					setTimeout(()=>{
						setAlertView('hidden');
					},2400);
					setDisableButton(false);
					setMessage({message:"Error Failed to book please try again or contact support",status: "error"})
				}

			}).catch(error => {
				// Handle promise rejection/errors
				console.error('Error sending email:', error);
				setAlertView('visible');
				setTimeout(()=>{
					setAlertView('hidden');
				},2400);
				setDisableButton(false);
				setMessage({message:"Error Failed to book please try again or contact support",status: "error"})
			})
		}

	}
	// If required props are missing, show error message
	if (!props.employee || !props.currentDate || !props.timeSlot) {
		return (
			<React.Fragment>
				<BodyContainer {...props} childComponent={
					<div className={'col'} style={{textAlign:'center',color:"black",paddingTop:'80px'}}>
						<Alert severity="error" style={{maxWidth:'600px',margin:'0 auto'}}>
							<h3>Missing Booking Information</h3>
							<p>It looks like you accessed this page directly without selecting an appointment time.</p>
							<p>Please go back to the booking calendar and select an available time slot.</p>
							<Button 
								variant="contained" 
								color="primary" 
								onClick={() => history.push(`/locations/${brandLocation}/booking`)}
								style={{marginTop:'20px'}}
							>
								Go to Booking Calendar
							</Button>
						</Alert>
					</div>
				}/>
			</React.Fragment>
		);
	}

	return(<React.Fragment>
			 <BodyContainer {...props} childComponent={<React.Fragment>
				 { loading ? <div className={'col'}><div style={{display:'flex',justifyContent:'center',marginTop:'80px'}}><CircularProgress /></div></div> :showPage ? showForm ? <div style={{marginRight:'auto',marginLeft:'auto',paddingTop:'30px'}}>
					<h4>Bevestig uw afspraak</h4>
					 <div style={{flexDirection:isMobile ? 'column':'row'}} className={'col flex centerItems'}>
						 {isMobile ? <div>
							 {/*'col col-lg-4 col-md-6 col-sm-6*/}
							 <div  className={'form'} style={{paddingTop:'20px'}} >
								 <div className={'flex'}>
									 <Card style={{width:'100%',marginRight:'20px',background:`linear-gradient(180deg, #0C2E40 50%,white 50%)`}} className={classes.root}>
										 <CardActionArea >
											 <div className={"imageContainer"}>
												 <CardMedia
														component="img"
														alt={props.employee?.name || 'Employee'}
														height="150px"
														id={`${props.employee?.name?.split(" ").join('') || 'employee'}`}
														style={{objectFit:"cover",width:'150px',borderRadius:'50%',fontFamily:'obvia,sans-serif'}}
														image={image}
														title={props.employee?.name || 'Employee'}
												 />
												 <StyledBadge
														overlap="circle"
														anchorOrigin={{
															vertical: 'bottom',
															horizontal: 'right',
														}}
														style={{position:'absolute',right:'35%',bottom:'55%'}}
														variant="dot"
												 />
											 </div>

											 <CardContent>
												 <Typography style={{fontFamily:'obvia,sans-serif'}} gutterBottom variant="h5" component="h2">
													 {props.employee?.name || 'N/A'}
												 </Typography>
												 <Typography style={{fontFamily:'obvia,sans-serif'}} variant="body2"  component="p">
													 Locatie : {props.brand?.currentLocationFullName || brandLocation || 'N/A'}
												 </Typography>
												 <Typography style={{fontFamily:'obvia,sans-serif'}} variant="body2"  component="p">
													 Vanaf : {props.currentDate?.toLocaleDateString('nl-BE',{ weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' }) || 'N/A'} - {props.timeSlot || 'N/A'}
												 </Typography>
											 </CardContent>
										 </CardActionArea>
									 </Card>

								 </div>
							 </div>
						 </div>: <div style={{marginRight:'41px'}} className={''}>
							 {/*'col col-lg-4 col-md-6 col-sm-6*/}
							 <div style={{maxWidth:'256px'}} className={'form'}>
								 <div className={'flex flex-column'}>
									 <Card style={{background:`linear-gradient(180deg, #0C2E40 50%,white 50%)`}} className={classes.root}>
										 <CardActionArea >
											 <div className={"imageContainer"}>
												 <CardMedia
														component="img"
														alt={props.employee?.name || 'Employee'}
														height="110px"
														id={`${props.employee?.name?.split(" ").join('') || 'employee'}`}
														style={{objectFit:"cover",width:'110px',borderRadius:'50%'}}
														image={image}
														title={props.employee?.name || 'Employee'}
												 />
												 <StyledBadge
														overlap="circle"
														anchorOrigin={{
															vertical: 'bottom',
															horizontal: 'right',
														}}
														style={{position:'absolute',right:'93px',bottom:'120px'}}
														variant="dot"
												 />
											 </div>

											 <CardContent>
												 <Typography style={{fontFamily:'obvia,sans-serif'}} gutterBottom variant="h5" component="h2">
													 {props.employee?.name || 'N/A'}
												 </Typography>
												 <Typography style={{fontFamily:'obvia,sans-serif'}} variant="body2"  component="p">
													 Locatie : {brandLocation || 'N/A'}
												 </Typography>
												 <Typography style={{fontFamily:'obvia,sans-serif'}} variant="body2"  component="p">
													 Vanaf : {props.currentDate?.toLocaleDateString('nl-BE',{ weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' }) || 'N/A'} - {props.timeSlot || 'N/A'}
												 </Typography>
											 </CardContent>
										 </CardActionArea>
									 </Card>

								 </div>
							 </div>
						 </div>}
						 <div className={''}>
							 {/*col col-lg-8 col-md-6 col-sm-7*/}
							 <div className={'form'}>
								 <div className={'formContainer'}>
									 <form  ref={formRef}  className={'container'}  autoComplete="on">
										 <h4>Persoonlijke gegevens</h4>
										 <FormControl error={formErrors.voornaam}>
											 <TextField error={formErrors.voornaam} name={"voornaam"} onChange={handleChange} required label="Voornaam" />
											 {formErrors.voornaam ? <FormHelperText >Please enter your first name</FormHelperText>:''}
										 </FormControl>
										 <FormControl error={formErrors.naam}>
											 <TextField error={formErrors.naam} name={'naam'} onChange={handleChange} required  label="Naam" />
											 {formErrors.naam ? <FormHelperText >Please enter your last/mid name</FormHelperText>:''}
										 </FormControl>
										 <FormControl error={formErrors.telefoonNummber}>
											 <TextField error={formErrors.telefoonNummber} name={'telefoonNummber'} onChange={handleChange} type="number" required  label="Telefoon Nummer" />
											 {formErrors.telefoonNummber ? <FormHelperText >Please enter your phone</FormHelperText>:''}
										 </FormControl>
										 <FormControl error={formErrors.emailAdres}>
											 <TextField error={formErrors.emailAdres} name={'emailAdres'} onChange={handleChange} required  label="E-mailadres " />
											 {formErrors.emailAdres ? <FormHelperText >Please Enter Valid Email Address</FormHelperText>:''}
										 </FormControl>
										 <FormControl >
											 <InputLabel id="demo-simple-select-label">Brand</InputLabel>
											 <Select
													labelId="demo-simple-select-label"
													id="demo-simple-select"
													value={selectedBrand || ''}
													name={'brand'}
													onChange={handleChange}
											 >
												 {brands.map(item=>{
												 	return  <MenuItem key={item.name} value={item.name}>{item.name}</MenuItem>
												 })}
											 </Select>
										 </FormControl>
										 <TextField error={formErrors.model} name={'model'} onChange={handleChange} label="Model" />
										 <TextField error={formErrors.adres} name={'adres'} onChange={handleChange} label="Adres" />
										 <TextField error={formErrors.huidingVoertuigNummerPlat} name={'huidingVoertuigNummerPlat'} onChange={handleChange} label={"Huidig voertuig + nummerplaat"}/>
										 {/*<TextField
												error={formErrors.proefritGewenst}
												id="standard-select-currency"
												select
												required
												label="Proefrit gewenst"
												name={'proefritGewenst'}
												value={selectedOption}
												onChange={(event)=>{setSelectedOption(event.target.value);
													handleChange(event);
												}}
										 >
											 {options.map((option) => (
													<MenuItem key={option.value} value={option.value}>
														{option.label}
													</MenuItem>
											 ))}
										 </TextField>*/}
										 <TextField onChange={handleChange}
																id="outlined-multiline-static"
																label="Extra Info"
																multiline
																rows={4}
																defaultValue={props.urlSearchParam ? `Ik ben geïnteresseerd in volgende wagen: \n\r ${props.urlSearchParam}`:null}
																error={formErrors.extraInfo}
																name={"extraInfo"}
																variant="outlined"
										 />
										 <FormControlLabel
												control={<Checkbox color="primary" checked={acceptPrivacyPolicy} onChange={()=>{ setPrivacyPolicy(!acceptPrivacyPolicy)}} name="checkedA" />}
												label={<span style={{color:'black'}} >Ik ga akkoord met de <a target={"_blank"} rel="noopener noreferrer" href={'https://jorssen.be/bmw/privacy-policy/'}>Privacy Policy</a></span>}
										 />


										 <Button  disabled={!acceptPrivacyPolicy || submitDisableButton} onClick={()=>{

											 sendEmails()
										 }} variant="contained" color="primary">
											 Submit {submitDisableButton ? <CircularProgress style={{marginLeft:"10px"}} size={20} />:''}
										 </Button>

									 </form>
								 </div>
							 </div>
						 </div>
					 </div>
				 </div>:<div className={'col'} style={{textAlign:'center',color:"black"}}>
					 <Lottie
							options={defaultOptions}
							height={400}
							width={400}
					 />
					 <h3>Uw aanvraag is verzonden.</h3>
					 <h3>U ontvangt zo dadelijk een bevestiging via email.</h3>
				 </div> :''}

			 </React.Fragment>}/>
		<Alert   style={{width:'fit-content',position:'absolute',top:'18%',left:'0',right:'0',marginLeft:'auto',marginRight:'auto',visibility:alert}} severity={message.status}>{message.message}</Alert>
		 </React.Fragment>)
}
